import { Delete } from "@mui/icons-material";
import { Avatar, Box, Grid, IconButton, Rating } from "@mui/material"; // Use `Grid` instead of `Grid2`
import { red } from "@mui/material/colors";
import React from "react";
import { ReviewRes } from "../../../types/reviewType";
import { formatDate } from "../../../utils/formatDate";
import { useAppDispatch } from "../../../State/Store";
import { deleteReview } from "../../../State/customer/ReviewSlice";

export const ReviewCard = ({ review }: { review: ReviewRes | null }) => {
  const dispatch = useAppDispatch();
  const handleDelete = (reviewId: number | null) => {
    if (reviewId != null) {
      dispatch(deleteReview(reviewId));
    }
  };
  return (
    <div className="flex justify-between py-3 w-[100%] bg-[#dae0e2] rounded-md p-5">
      {/* Use `Grid` instead of `Grid2`, as `Grid2` might not support `size` prop */}
      <Grid container spacing={2} sx={{ gap: { xs: 3, xl: 5 } }}>
        {/* Left Avatar */}
        <Grid item xs={2} xl={1}>
          <Box>
            <Avatar
              className="text-white"
              sx={{ width: 56, height: 56, bgcolor: "#9155FD" }}
            >
              {review?.user.fullName?.charAt(0)}{" "}
              {/* Show first letter as avatar */}
            </Avatar>
          </Box>
        </Grid>

        {/* Review Content */}
        <Grid item xs={7} xl={9}>
          <div className="space-y-2">
            <div>
              <p className="font-semibold text-lg">{review?.user.fullName}</p>
              <p className="opacity-70">
                {formatDate(review?.createdAt || "")}
              </p>
            </div>

            {/* Rating */}
            <Rating readOnly value={review?.rating} precision={0.5} />

            {/* Review Text */}
            {review?.reviewText && <p>{review.reviewText}</p>}

            {/* Render Images Correctly */}
            {review?.images && (
              <div className="flex gap-2">
                {review.images.map((item, index) => (
                  <div key={index} className="">
                    <img
                      className="w-24 h-24 object-cover rounded-md"
                      src={item}
                      alt=""
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </Grid>
      </Grid>

      {/* Delete Button */}
      <div>
        {review?.id && (
          <IconButton
            onClick={() => {
              handleDelete(review.id);
            }}
          >
            <Delete sx={{ color: red[700] }} />
          </IconButton>
        )}
      </div>
    </div>
  );
};
